// 全角→半角(英数字)
export const transformFullCharToHalf = (str: string) => {
  return str.replace(/[！-～]/g, (s: string) => {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });
};
